import React from 'react';
import axios from './../../../constants/axios';
import { Button, Table } from 'react-bootstrap';
import './PresentStock.less';
import alert from 'alertify.js';

class PresentStock extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         presentStock: [],
         total: 0,
         stockChangeButtonDisable: false,
      };
   }

   componentDidMount() {
      axios('stocks')
         .then((res) => {
            this.setState({
               presentStock: res.data.items,
               total: res.data.total
            });
         });
   }

   changeDamageQuantity = (quantity, stockId) => {
      this.setState({
         stockChangeButtonDisable: true,
      });
      axios
         .post('stocks/changeDamageUnit', {
            quantity,
            stockId
         })
         .then((res) => {
            if (res.status === 201) {
               alert.success(res.data);
               const modifiedData = this.state.presentStock.map((i) => {
                  if (i.id === stockId) {
                     return Object.assign({}, i, {
                        damage_unit: i.damage_unit + (quantity),
                        unit_on_hand: i.unit_on_hand + (quantity * -1),
                     });
                  } else {
                     return i;
                  }
               });
               this.setState({
                  stockChangeButtonDisable: false,
                  presentStock: modifiedData,
               });
            } else {
               alert.error(res.data);
               this.setState({
                  stockChangeButtonDisable: false,
               });
            }
         })
         .catch((err) => {
            this.setState({
               stockChangeButtonDisable: false,
            });
            alert.error(err.response.data);
         });
   };

   render() {
      const { stockChangeButtonDisable } = this.state;
      return (
         <div>
            <h3>Present Stock Level</h3>
            <h4>Total Stock Value: {this.state.total}</h4>
            <Table striped bordered condensed >
               <thead>
               <tr>
                  <th>Stock Id</th>
                  <th>Item Id</th>
                  <th>Item</th>
                  <th>Avg Purchase Price</th>
                  <th>On Hand Unit</th>
                  <th>Damage Unit</th>
               </tr>
               </thead>

               <tbody>
               {this.state.presentStock.map((item) => (
                  <tr key={item.id} >
                     <td>{item.id}</td>
                     <td>{item.item_id}</td>
                     <td>{item.name}</td>
                     <td>{item.avg_purchase_price}</td>
                     <td>{item.unit_on_hand}</td>
                     <td className="buttonContainer" >
                        <Button disabled={stockChangeButtonDisable}
                                onClick={() => this.changeDamageQuantity(-1, item.id)} >-</Button>
                        {item.damage_unit}
                        <Button disabled={stockChangeButtonDisable}
                                onClick={() => this.changeDamageQuantity(1, item.id)} >+</Button>
                     </td>
                  </tr>
               ))}
               </tbody>
            </Table>
         </div>
      );
   }
}

export default PresentStock;



/** WEBPACK FOOTER **
 ** ./src/components/StockManagement/PresentStock/PresentStock.js
 **/